import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as ClaimTrackerModels from '@claim-tracker/common/models';
import { catchError, EMPTY, Observable, tap } from 'rxjs';

import { PageLevelMessageService } from '../../shared/messages/page-level-message/page-level-message.service';
import { ClaimNumberService } from '../../shared/services/claim-number/claim-number.service';
import { NavService } from '../../shared/services/nav/nav.service';

/**
 * Service to fetch the claim details.
 *
 * @author Jesse Bloomster e020902
 */
@Injectable()
export class ClaimDetailsService {
	private readonly claimDetailsUrl = '/gateway/claimDetails';
	private readonly UNAUTHENTICATED_HTTP_STATUS_CODE = 401;

	/**
	 * @param http the Angular Http Client
	 * @param navService the navigation service
	 * @param messageService the global page level message service
	 * @param claimNumberService the global claim number service
	 */
	constructor(
		private http: HttpClient,
		private navService: NavService,
		private messageService: PageLevelMessageService,
		private claimNumberService: ClaimNumberService
	) {}

	/**
	 * Get the claim details.
	 */
	getClaimDetails(): Observable<ClaimTrackerModels.com.aoins.claims.claim.Claim> {
		return this.http.get<ClaimTrackerModels.com.aoins.claims.claim.Claim>(this.claimDetailsUrl).pipe(
			tap(claim => this.claimNumberService.updateClaimNumber(claim.claimNumber ?? null)),
			catchError((err: unknown) => {
				// we don't want to add an error message for an unauthenticated user
				if (err instanceof HttpErrorResponse && err.status !== this.UNAUTHENTICATED_HTTP_STATUS_CODE) {
					this.messageService.addPageLevelMessage({
						text: 'A system error has occurred. Try again.',
						style: 'ao-page-error'
					});
				}

				this.navService.toTrackAClaim();

				return EMPTY;
			})
		);
	}
}
